function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Green-Version",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "03_Dashboard_Green",
  transform: "translate(-234.000000, -101.000000)",
  fill: "#057A52",
  stroke: "#327954",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/other/medium/downarrow-Copy",
  transform: "translate(238.500000, 109.000000) scale(1, -1) rotate(90.000000) translate(-238.500000, -109.000000) translate(230.500000, 104.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.03669571,4.49959232 L11.8738249,-2.27462214 C12.0420584,-2.44130747 12.0420584,-2.70838908 11.8738249,-2.87507441 C11.7057502,-3.04164186 11.4360294,-3.04164186 11.2679547,-2.87507441 L4.12608582,4.20107548 C3.95797139,4.36760363 3.95797139,4.63484242 4.12608582,4.80137058 L11.2679547,11.8742984 C11.350366,11.9561086 11.4614508,12 11.569244,12 C11.6770767,12 11.7881615,11.9591735 11.8707315,11.8742984 C12.0388063,11.7077702 12.0388063,11.4405314 11.8707315,11.2740033 L5.03669571,4.49959232 Z",
  id: "Fill-1",
  transform: "translate(8.000000, 4.500000) rotate(-90.000000) translate(-8.000000, -4.500000) "
}))));

function SvgLeftarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "755BD51D-E3AA-481E-A486-87459834EF75") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.c7e902b6.svg";
export { ForwardRef as ReactComponent };